<template>
  <div
    class="sb-switch"
    data-sb-regression="sb-switch"
  >
    <label
      :id="id"
      class="sb-switch-container"
    >
      <input
        class="input"
        type="checkbox"
        tabindex="-1"
        :checked="checked"
        :aria-labelledby="id"
        :aria-pressed="checked"
        :disabled="isDisabled"
        @change="handleCheckboxChange($event.target.checked)"
      >
      <span
        tabindex="0"
        :class="['switch', variation]"
        role="switch"
        :aria-label="checked ? 'on': 'off'"
        :aria-checked="checked ? true : false"
        @keyup.enter="handleEnterPress"
      />
      <span class="label">{{ checked ? toggleOnText : toggleOffText }}</span>
    </label>
  </div>
</template>

<script>

import uuid from '@src/utils/uuid';

/**
 * Switch components allow the user to select on or off.
 * This acts like a checkbox but in a different more visible styling.
 */
export default {
  name: 'SbSwitch',
  props: {
    /**
     * enabled or disabled
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * If the option is on or off
     */
    checked: {
      type: Boolean,
      default: false,
    },
    /**
     * Text to show when the switch is on
     */
    toggleOnText: {
      type: String,
      default: '',
    },
    /**
     * Text to show when the switch is off
     */
    toggleOffText: {
      type: String,
      default: '',
    },
    /**
     * The style variation of the switch
     */
    variation: {
      type: String,
      default: 'primary',
      validator: (value) => value.match(/(primary|secondary)/),
    },
  },
  emits: [
    /**
     * Emitted when switch component value changes
     * @param {bool} value
     */
    'sb-switch-update-checked',
  ],
  data: () => {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = uuid();
  },
  methods: {
    handleCheckboxChange(value) {
      this.$emit('sb-switch-update-checked', value);
    },
    handleEnterPress() {
      this.$emit('sb-switch-update-checked', !this.checked);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@src/components/Switch/style/sb-switch.scss';
</style>
